module.exports = "<!doctype html>\n<html>\n  <head>\n    <meta charset=\"utf-8\">\n  </head>\n\n  <body>\n    <!-- Will be replaced by React -->\n    <div id=\"root\"></div>\n  </body>\n\n</html>\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/hello-shell.example
// module id = 1476
// module chunks = 0